import React from "react";
import PropTypes from "prop-types";
import makeStyles from "@material-ui/core/styles/makeStyles";
const useStyles = makeStyles(() => ({
    currentPage: {
        paddingTop: 3,
        fontSize: '0.75rem'
    },
}));
const PageNumber = (props) => {
    const {isInput, pageValue, changePageInputState, page, totalElements, handleChangePage, handleKeyDown} = props;
    const classes = useStyles();
    return (
        <span
            onClick={() => changePageInputState(true)}
            onBlur={() => changePageInputState(false)}
            className={classes.currentPage}>
                {isInput ? (
                    <input
                        type="number"
                        className={'tableInput'}
                        style={{width: (pageValue.toString().length + 1) * 6}}
                        onKeyDown={handleKeyDown}
                        onChange={handleChangePage}
                        value={pageValue}
                        min="1"
                        max={totalElements}
                        autoFocus
                    />
                ) : (
                    page + 1
                )}
            </span>
    )
};
PageNumber.propTypes = {
    isInput: PropTypes.bool,
    pageValue: PropTypes.number,
    page: PropTypes.number,
    totalElements: PropTypes.number,
    changePageInputState: PropTypes.func,
    handleChangePage: PropTypes.func,
    handleKeyDown: PropTypes.func
};
export default PageNumber